import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import './i18n';

ReactDOM.render(<App />, document.getElementById('root'));
